import { apiFetch } from './api';
import { serverOrigin } from './server-origin';

// Admin → System → Email deliverability. Mirrors server
// email/deliverability.ts + email/event-webhook.ts.

export type Health = 'no-data' | 'low-volume' | 'good' | 'warning' | 'critical';

export interface DeliverabilitySummary {
  sent: number;
  delivered: number;
  deferred: number;
  bounced: number;
  dropped: number;
  spamReports: number;
  unsubscribes: number;
  deliveryRate: number | null;
  bounceRate: number | null;
  dropRate: number | null;
  spamRate: number | null;
  health: Health;
  alerts: Array<{ level: 'warning' | 'critical'; metric: 'bounce' | 'spam' | 'dropped'; message: string }>;
}

export interface DeliverabilityReport {
  days: number;
  summary: DeliverabilitySummary;
  byKind: Array<{ kind: string; summary: DeliverabilitySummary }>;
  problems: Array<{
    at: string;
    event: string;
    email: string;
    kind: string | null;
    reason: string | null;
    smtpStatus: string | null;
    bounceType: string | null;
    siteName: string | null;
  }>;
  webhook: { keyConfigured: boolean; lastEventAt: string | null };
}

export const getDeliverability = (days: number) =>
  apiFetch<DeliverabilityReport>(`/api/admin/system-config/email-deliverability?days=${days}`);

/** '' clears the key (the webhook then refuses every post). */
export const setEventWebhookKey = (publicKey: string) =>
  apiFetch<{ keyConfigured: boolean }>('/api/admin/system-config/email-events-key', {
    method: 'PUT',
    body: JSON.stringify({ publicKey }),
  });

/** The HTTP Post URL to paste into SendGrid's Event Webhook settings. */
export const eventWebhookUrl = () => `${serverOrigin()}/api/email/events`;

export const KIND_LABEL: Record<string, string> = {
  'channel-reply': 'Support replies',
  'chat-end': 'Chat transcripts',
  'password-reset': 'Password resets',
  'verify-email': 'Email verifications',
  'agent-invite': 'Agent invites',
  'site-assigned': 'Site assignments',
  'csat-survey': 'CSAT surveys',
  test: 'Test emails',
  other: 'Untagged',
};
